import { useState } from 'react'
import useInterval from './useInterval'

function useDate(interval?: number): Date {
  const [date, setDate] = useState(new Date())

  useInterval(() => {
    setDate(new Date())
  }, interval || 1000)

  return date
}

export default useDate
